import { useEffect, useRef } from 'react';
import { APP_VERSION } from '../config/version';

const CHECK_INTERVAL = 60 * 1000; // 60 秒

export default function useVersionCheck(onNewVersion) {
  const notifiedRef = useRef(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const check = async () => {
      if (notifiedRef.current) return;
      try {
        const res = await fetch('/version.json?t=' + Date.now());
        if (!res.ok) return;
        const data = await res.json();
        if (data.version && data.version !== APP_VERSION) {
          notifiedRef.current = true;
          onNewVersion(data.version);
        }
      } catch {
        // 静默忽略网络错误
      }
    };

    const start = () => {
      check();
      timerRef.current = setInterval(check, CHECK_INTERVAL);
    };

    const stop = () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };

    const handleVisibility = () => {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    };

    start();
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      stop();
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [onNewVersion]);
}
